import { render, staticRenderFns } from "./VerbTensesPreview.vue?vue&type=template&id=63cc5804&lang=pug&"
import script from "./VerbTensesPreview.vue?vue&type=script&lang=js&"
export * from "./VerbTensesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports